const { jStat } = require('jstat')
const { polynomial } = require('regression')

function distance(x1, y1, x2, y2) {
  const dx = x2 - x1
  const dy = y2 - y1
  return Math.sqrt(dx * dx + dy * dy)
}

function getFurthestDistance (points) {
  let furthestDistance = 0;

  for (let i = 0; i < points.length; i++) {
    for (let j = 0; j < points.length; j++) {
      const dist = distance(points[i].x, points[i].y, points[j].x, points[j].y)
      if (dist > furthestDistance) {
        furthestDistance = dist;
      }
    }
  }

  return furthestDistance;
}

function gaussianRandom(standardDeviation, mean) {
  let u = 0, v = 0;
  while (u === 0) {
    u = Math.random();
  }
  while (v === 0) {
    v = Math.random();
  }
  let normalRandom = Math.sqrt(-2.0 * Math.log(u)) * Math.cos(2.0 * Math.PI * v);
  return standardDeviation * normalRandom + mean;
}

function rayleighProbabiltyDensity (x, s) {
  const exp = (-1 * Math.pow(x, 2)) / (2 * Math.pow(s, 2))
  const base = x / Math.pow(s, 2)
  const p = base * Math.pow(Math.E, exp)
  return p
}

function chiPDF(x, k) {
  if (x < 0 || k <= 0) {
    return 0
  }
  const numerator = Math.pow(x, k - 1) * Math.exp(-Math.pow(x, 2) / 2)
  const denominator = Math.pow(2, k/2 - 1) * gamma(k/2)
  return numerator / denominator
}

function weibullPDF(x, lambda, k) {
  if (x < 0 || lambda <= 0 || k <= 0) {
    return 0
  }
  return k / lambda * Math.pow(x / lambda, k - 1) * Math.pow(Math.E, -Math.pow(x / lambda, k))
}

function chiRandom(sd, df = 1.6, sdScale = .75) {
  // Marsaglia and Tsang method for generating Gamma variables
  function gammaHelper(shape, scale) {
    var d, c, x, v, u;
    if (shape < 1) {
      return gammaHelper(shape + 1, scale) * Math.pow(Math.random(), 1 / shape);
    }
    d = shape - 1 / 3;
    c = 1 / Math.sqrt(9 * d);
    for (;;) {
      do {
        x = gaussianRandom(1, 0);
        v = 1 + c * x;
      } while (v <= 0);
      v = v * v * v;
      u = Math.random();
      if (u < 1 - 0.0331 * (x * x) * (x * x)) return scale * d * v;
      if (Math.log(u) < 0.5 * x * x + d * (1 - v + Math.log(v))) return scale * d * v;
    }
  }

  return Math.sqrt(gammaHelper(0.5 * df, 2)) * (sd * sdScale);
}

function standardDeviation (array, mean = null) {
  if (!array || !array.length) return 0
  const n = array.length
  if (mean === null) {
    mean = array.reduce((a, b) => a + b) / n
  }
  return Math.sqrt(array.map(x => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / n)
}

function average (array) {
  let sum = 0
  for (let i = 0; i < array.length; ++i) {
    sum += array[i]
  }
  return sum / array.length
}

function calculateCEPRayleigh (distances, percentile) {
  // Calculate the scale parameter of the Rayleigh distribution
  const sigma = Math.sqrt(distances.reduce((sum, distance) => sum + (distance * distance), 0) / (2 * distances.length));

  // Calculate the CEP using the Rayleigh distribution formula for the given percentile
  const CEP = sigma * Math.sqrt(-2 * Math.log(1 - (percentile / 100)));

  return CEP;
}

function calculateCEPGaussian(points) {
  // Calculate the mean of the x and y coordinates of the points
  let xMean = points.reduce((sum, p) => sum + p.x, 0) / points.length;
  let yMean = points.reduce((sum, p) => sum + p.y, 0) / points.length;

  // Calculate the square root of the sum of the squared distances from the mean
  let squaredDistances = points.reduce((sum, p) => {
    let dx = p.x - xMean;
    let dy = p.y - yMean;
    return sum + dx * dx + dy * dy;
  }, 0);
  let rootMeanSquare = Math.sqrt(squaredDistances / points.length);

  // Calculate the CEP as the root mean square multiplied by a constant factor
  let cep = rootMeanSquare * 0.597;

  return cep;
}

//function calculateCEPChi(points) {
//  // Calculate the mean values of the x and y coordinates
//  const xMean = points.reduce((sum, point) => sum + point.x, 0) / points.length;
//  const yMean = points.reduce((sum, point) => sum + point.y, 0) / points.length;
//
//  // Calculate the sum of squared distances from the mean
//  const sumOfSquares = points.reduce((sum, point) => {
//    const xDiff = point.x - xMean;
//    const yDiff = point.y - yMean;
//    return sum + (xDiff * xDiff) + (yDiff * yDiff);
//  }, 0);
//
//  // Calculate the CEP using the chi distribution formula
//  const n = points.length;
//  const CEP = Math.sqrt((2 / n) * sumOfSquares);
//
//  return CEP;
//}

const g = 7;
const p = [
    0.99999999999980993,
    676.5203681218851,
    -1259.1392167224028,
    771.32342877765313,
    -176.61502916214059,
    12.507343278686905,
    -0.13857109526572012,
    9.9843695780195716e-6,
    1.5056327351493116e-7
];

const g_ln = 607/128;
const p_ln = [
    0.99999999999999709182,
    57.156235665862923517,
    -59.597960355475491248,
    14.136097974741747174,
    -0.49191381609762019978,
    0.33994649984811888699e-4,
    0.46523628927048575665e-4,
    -0.98374475304879564677e-4,
    0.15808870322491248884e-3,
    -0.21026444172410488319e-3,
    0.21743961811521264320e-3,
    -0.16431810653676389022e-3,
    0.84418223983852743293e-4,
    -0.26190838401581408670e-4,
    0.36899182659531622704e-5
];

// Spouge approximation (suitable for large arguments)
function lngamma(z) {

    if(z < 0) return Number('0/0');
    var x = p_ln[0];
    for(var i = p_ln.length - 1; i > 0; --i) x += p_ln[i] / (z + i);
    var t = z + g_ln + 0.5;
    return .5*Math.log(2*Math.PI)+(z+.5)*Math.log(t)-t+Math.log(x)-Math.log(z);
}

function gamma (z) {
    if (z < 0.5) {
        return Math.PI / (Math.sin(Math.PI * z) * gamma(1 - z));
    }
    else if(z > 100) return Math.exp(lngamma(z));
    else {
        z -= 1;
        var x = p[0];
        for (var i = 1; i < g + 2; i++) {
            x += p[i] / (z + i);
        }
        var t = z + g + 0.5;

        return Math.sqrt(2 * Math.PI)
            * Math.pow(t, z + 0.5)
            * Math.exp(-t)
            * x
        ;
    }
}

function linearRegression(points) {
  if (!Array.isArray(points) || points.length < 2) {
    throw new Error('Invalid input: points should be an array with at least 2 elements');
  }

  let sumX = 0;
  let sumY = 0;
  let sumXY = 0;
  let sumX2 = 0;
  let sumY2 = 0;
  let n = points.length;

  for (let i = 0; i < n; i++) {
    let { x, y } = points[i];

    if (typeof x !== 'number' || typeof y !== 'number') {
      throw new Error('Invalid input: points should have numerical x and y properties');
    }

    sumX += x;
    sumY += y;
    sumXY += x * y;
    sumX2 += x * x;
    sumY2 += y * y;
  }

  let meanX = sumX / n;
  let meanY = sumY / n;

  let m = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX * sumX);
  let b = meanY - m * meanX;

  let ssTot = sumY2 - (sumY * sumY) / n;
  let ssRes = sumY2 - m * sumXY - b * sumY;
  let rSquared = 1 - (ssRes / ssTot);

  // Calculating the standard errors for slope and intercept
  let s = Math.sqrt(ssRes / (n - 2));
  let SE_m = s / Math.sqrt(sumX2 - (sumX * sumX) / n);
  let SE_b = s * Math.sqrt(sumX2 / (n * (n * sumX2 - sumX * sumX)));

  // Calculating the t-statistics for slope and intercept
  let t_m = m / SE_m;
  let t_b = b / SE_b;

  // Calculating the p-values for the t-statistics
  let p_value_m = 2 * (1 - jStat.studentt.cdf(Math.abs(t_m), n - 2));
  let p_value_b = 2 * (1 - jStat.studentt.cdf(Math.abs(t_b), n - 2));

  return { m, b, rSquared, p_value_m, p_value_b };
}

function quadraticRegression(points) {
  const data = points.map(p => [p.x, p.y])
  const result = polynomial(data, { order: 2, precision: 15 })
  console.log(result)
  return {
    a: result.equation[0],
    b: result.equation[1],
    c: result.equation[2],
    rSquared: result.r2
  }
}

function tTest(sample1, sample2, tails = 2) {
    if (tails !== 1) tails = 2
    var mean1 = jStat.mean(sample1);
    var mean2 = jStat.mean(sample2);
    var sd1 = jStat.stdev(sample1, true);
    var sd2 = jStat.stdev(sample2, true);

    var t = (mean1 - mean2) / Math.sqrt(sd1*sd1/sample1.length + sd2*sd2/sample2.length);

    // degrees of freedom
    var df = sample1.length + sample2.length - 2;

    // calculate the p-value
    var p = jStat.ttest(t, df, tails);  // 2-tailed test

    return { t, p, mean1, mean2, sd1, sd2 };
}

function fTest(arr1, arr2, tails = 2) {  // Added 'tails' parameter with a default value of 2 (two-tailed)
  function variance(arr) {
    const mean = arr.reduce((sum, val) => sum + val, 0) / arr.length;
    return arr.reduce((sum, val) => sum + Math.pow(val - mean, 2), 0) / (arr.length - 1);
  }
  const mean1 = jStat.mean(arr1);
  const mean2 = jStat.mean(arr2);
  const sd1 = jStat.stdev(arr1, true);
  const sd2 = jStat.stdev(arr2, true);

  const variance1 = variance(arr1);
  const variance2 = variance(arr2);
  let f = variance1 / variance2; // Ratio of the two variances

  const df1 = arr1.length - 1; // Degrees of freedom for arr1
  const df2 = arr2.length - 1; // Degrees of freedom for arr2

  let p;

  if (tails === 2) { // Two-tailed test
    if (variance1 > variance2) {
      p = 2 * (1 - jStat.centralF.cdf(f, df1, df2));
    } else {
      f = variance2 / variance1; // Reverse the ratio if v2 > v1
      p = 2 * (1 - jStat.centralF.cdf(f, df2, df1));
    }
  } else if (tails === 1) { // One-tailed test
    if (variance1 > variance2) {
      p = 1 - jStat.centralF.cdf(f, df1, df2);
    } else {
      f = variance2 / variance1; // Reverse the ratio if v2 > v1
      p = 1 - jStat.centralF.cdf(f, df2, df1);
    }
  } else {
    throw new Error("Invalid value for 'tails'. It should be either 1 or 2.");
  }

  return {
    mean1,
    mean2,
    sd1,
    sd2,
    variance1,
    variance2,
    f,
    p
  };
}

function groupCenter (points) {
  let groupX = 0
  let groupY = 0
  for (let i = 0; i < points.length; i++) {
    groupX += points[i].x
    groupY += points[i].y
  }
  groupX /= points.length
  groupY /= points.length
  return { x: groupX, y: groupY }
}

// Compute delta, the within-group average distance for a set of points
function withinGroupDistance(points) {
  let sumDistance = 0;
  let count = 0;

  for (let i = 0; i < points.length; i++) {
    for (let j = i + 1; j < points.length; j++) {
      sumDistance += distance(points[i].x, points[i].y, points[j].x, points[j].y);
      count++;
    }
  }

  return sumDistance / count;
}

// Calculate MRPP p-value between two arrays of points
function calculateMRPPpValue(group1, group2, numPermutations) {
  const allPoints = group1.concat(group2);
  const observedDeltaA = withinGroupDistance(group1) * group1.length + withinGroupDistance(group2) * group2.length;
  let countMoreExtreme = 0;

  for (let i = 0; i < numPermutations; i++) {
    // Shuffle all points
    const shuffledPoints = allPoints.sort(() => Math.random() - 0.5);

    // Split into new groups
    const newGroup1 = shuffledPoints.slice(0, group1.length);
    const newGroup2 = shuffledPoints.slice(group1.length);

    // Compute within-group distances for new groups
    const permutedDeltaA = withinGroupDistance(newGroup1) * newGroup1.length + withinGroupDistance(newGroup2) * newGroup2.length;

    // Count if permuted deltaA is more extreme than observed deltaA
    if (permutedDeltaA <= observedDeltaA) {
      countMoreExtreme++;
    }
  }

  // Calculate p-value
  const pValue = (countMoreExtreme + 1) / (numPermutations + 1);
  return pValue;
}

function mannWhitneyTest(a, b, pValue = .05, tail = 'different') {
  const u = mannWhitneyU(a, b)
  const mean1 = jStat.mean(a);
  const mean2 = jStat.mean(b);
  const sd1 = jStat.stdev(a, true);
  const sd2 = jStat.stdev(b, true);
  let p
  if (tail === 'different') {
    p = mannWhitneyPValue(u, a.length, b.length)
  } else {
    p = mannWhitneyOneTailedPValue(u, a.length, b.length, tail)
  }
  return { p, u, sd1, sd2, mean1, mean2 }
}

function mannWhitneyU(data1, data2) {
  const combined = data1.map(x => ({ value: x, group: 1 })).concat(data2.map(x => ({ value: x, group: 2 })));
  combined.sort((a, b) => a.value - b.value);

  let rankSum1 = 0;
  let rankSum2 = 0;
  let i = 0;

  while (i < combined.length) {
    let tiedValues = [combined[i]];
    let currentValue = combined[i].value;

    while (i + 1 < combined.length && combined[i + 1].value === currentValue) {
      i++;
      tiedValues.push(combined[i]);
    }

    const tiedRank = (tiedValues.length * (i + 1) - tiedValues.length * (tiedValues.length - 1) / 2) / tiedValues.length;

    for (const { group } of tiedValues) {
      if (group === 1) {
        rankSum1 += tiedRank;
      } else {
        rankSum2 += tiedRank;
      }
    }

    i++;
  }

  const u = Math.min(rankSum1 - (data1.length * (data1.length + 1)) / 2, rankSum2 - (data2.length * (data2.length + 1)) / 2);
  return u;
}

function mannWhitneyPValue(u, n1, n2) {
  const mean = standardNormalMean(n1, n2);
  const stdDev = standardNormalStdDev(n1, n2);
  const z = zScore(u, mean, stdDev);
  const pValue = 1 - normalCdf(Math.abs(z));

  return pValue;
}

function mannWhitneyOneTailedPValue(u, n1, n2, alternative = 'greater') {
  const mean = standardNormalMean(n1, n2);
  const stdDev = standardNormalStdDev(n1, n2);
  const z = zScore(u, mean, stdDev);

  if (alternative === 'greater') {
    return 1 - normalCdf(z);
  } else if (alternative === 'less') {
    return normalCdf(z);
  } else {
    throw new Error('Invalid alternative provided. Please use "greater" or "less".');
  }
}

function standardNormalMean(n1, n2) {
  return (n1 * n2) / 2;
}

// Calculate the standard deviation of the standard normal distribution
function standardNormalStdDev(n1, n2) {
  return Math.sqrt((n1 * n2 * (n1 + n2 + 1)) / 12);
}

function zScore(u, mean, stdDev) {
  return (u - mean) / stdDev;
}

function andersonDarlingTest(data) {
    let sortedData = data.slice().sort((a, b) => a - b);
    let mean = jStat.mean(sortedData);
    let stdDev = jStat.stdev(sortedData);
    let n = sortedData.length;
    let standardizedData = sortedData.map(x => (x - mean) / stdDev);

    let AD = -n - (1/n) * standardizedData.reduce((acc, yi, i) => {
        let cdf = jStat.normal.cdf(yi, 0, 1);
        const v = (2*i + 1) * (Math.log(cdf) + Math.log(1 - jStat.normal.cdf(standardizedData[n - 1 - i], 0, 1)));
        return acc + v
    }, 0);

    // Adjusted Anderson-Darling statistic
    let A2Star = AD * (1 + 0.75/n + 2.25/n**2);

    // Approximation of p-value (Stephens, 1974)
    let p;
    if (A2Star < 0.2) {
        p = 1 - Math.exp(-13.436 + 101.14 * A2Star - 223.73 * A2Star**2);
    } else if (A2Star < 0.34) {
        p = 1 - Math.exp(-8.318 + 42.796 * A2Star - 59.938 * A2Star**2);
    } else if (A2Star < 0.6) {
        p = Math.exp(0.9177 - 4.279 * A2Star - 1.38 * A2Star**2);
    } else if (A2Star < 10) {
        p = Math.exp(1.2937 - 5.709 * A2Star + 0.0186 * A2Star**2);
    } else {
        p = 0;
    }

    return { ADStatistic: AD, p };
}

function dAgostinoPearsonTest(data) {
    const n = data.length
    // Validate inputs
    if (n < 8) {
        //throw new Error('Sample size must be at least 8.');
      return { p : 0 }
    }

    const skewness = jStat.skewness(data);
    const kurtosis = 3 + jStat.kurtosis(data);

    // Calculate skewness statistics
    const y = skewness * Math.sqrt((n + 1) * (n + 3) / (6 * (n - 2)));
    const b = (3 * (n ** 2 + 27 * n - 70) * (n + 1) * (n + 3)) / ((n - 2) * (n + 5) * (n + 7) * (n + 9));
    const w2 = Math.sqrt(2 * (b - 1)) - 1;
    const d = 1 / Math.sqrt(Math.log(Math.sqrt(w2)));
    const a = Math.sqrt(2 / (w2 - 1));
    const Z_skewness = d * Math.log(y / a + Math.sqrt((y / a) ** 2 + 1));

    // Calculate kurtosis statistics
    const E_kurtosis = 3 * (n - 1) / (n + 1);
    const Var_kurtosis = 24 * n * (n - 2) * (n - 3) / ((n + 1) ** 2 * (n + 3) * (n + 5));
    const x = (kurtosis - E_kurtosis) / Math.sqrt(Var_kurtosis);
    const B = (6 * (n ** 2 - 5 * n + 2)) / ((n + 7) * (n + 9)) * Math.sqrt((6 * (n + 3) * (n + 5)) / (n * (n - 2) * (n - 3)));
    const A = 6 + (8 / B) * ((2 / B) + Math.sqrt(1 + (4 / B)));
    const pos = Math.pow((1 - 2 / A) / (1 + x * Math.sqrt(2 / (A - 4))), 1 / 3)
    const Z_kurtosis = (1 - 2 / (9 * A) - pos) / Math.sqrt(2 / (9 * A))

    // Calculate chi-squared statistic
    const chiSquare = Z_skewness ** 2 + Z_kurtosis ** 2;

    // Calculate p-value
    // As JavaScript does not have a built-in function for the chi-square CDF, you would typically
    // use a library like jStat or you can implement an approximation
    const p = 1 - jStat.chisquare.cdf(chiSquare, 2);

    return { skewness, kurtosis, p };
}

function kolmogorovSmirnov(sample) {
  const sortedSample = [ ...sample ].sort((a, b) => a - b);
  const mean = jStat.mean(sample);
  const sd = jStat.stdev(sample, true);
  let maxDiff = 0;

  for (let i = 0; i < sortedSample.length; i++) {
    const cdfValue = normalCdf(sortedSample[i], mean, sd);
    const edfValue = (i + 1) / sortedSample.length;
    const diff = Math.max(Math.abs(edfValue - cdfValue), Math.abs(cdfValue - (i > 0 ? (i - 1) / sortedSample.length : 0)));
    console.log({ diff, edfValue, cdfValue })
    maxDiff = Math.max(maxDiff, diff);
  }

  // Calculate p-value using the approximation
  const n = sample.length;
  const p = Math.exp(-2 * n * maxDiff * maxDiff);

  return { ksStatistic: maxDiff, p };
}

function normalCdf(value, mean = 0, sd = 1) {
  return 0.5 * (1 + erf((value - mean) / (Math.sqrt(2) * sd)));
}

function erf(x) {
  const a1 = 0.254829592;
  const a2 = -0.284496736;
  const a3 = 1.421413741;
  const a4 = -1.453152027;
  const a5 = 1.061405429;
  const p = 0.3275911;

  const sign = Math.sign(x);
  x = Math.abs(x);

  const t = 1 / (1 + p * x);
  const y = 1 - (((((a5 * t + a4) * t) + a3) * t + a2) * t + a1) * t * Math.exp(-x * x);

  return sign * y;
}

function createBins (data, numberOfBins) {
  const minData = Math.min(...data);
  const maxData = Math.max(...data);
  const range = maxData - minData;
  const binSize = range / numberOfBins;
  const bins = Array(numberOfBins).fill(0);

  data.forEach(stat => {
    const binIndex = Math.floor((stat - minData) / binSize);
    bins[binIndex < numberOfBins ? binIndex : numberOfBins - 1]++;
  });

  return bins.map((count, index) => ({
    bin: `${(minData + index * binSize).toFixed(2)}-${(minData + (index + 1) * binSize).toFixed(2)}`,
    count
  }));
}

function multipleLinearRegression(inputs, outputs) {
  console.log(inputs, outputs)
  inputs = transpose(inputs);
  // Number of data points
  let n = inputs.length;
  // Number of independent variables
  let m = inputs[0].length;

  // Add a column of ones to inputs to account for the intercept term (beta_0)
  let X = inputs.map(row => [1, ...row]); // (n x (m+1)) matrix
  let y = outputs.map(value => [value]); // (n x 1) column vector

  // Compute X transpose
  let Xt = transpose(X); // ((m+1) x n) matrix

  // Compute XtX = X^T * X
  let XtX = multiplyMatrices(Xt, X); // ((m+1) x (m+1)) matrix

  // Compute the inverse of XtX
  let XtX_inv;
  try {
    XtX_inv = inverseMatrix(XtX);
  } catch (e) {
    console.error('Error inverting matrix:', e);
    return null;
  }

  // Compute XtY = X^T * y
  let XtY = multiplyMatrices(Xt, y); // ((m+1) x 1) vector

  // Compute beta = XtX_inv * XtY
  let beta = multiplyMatrices(XtX_inv, XtY); // ((m+1) x 1) vector
  console.log(beta)

  // Flatten beta into a one-dimensional array
  beta = beta.map(row => row[0]);

  // Compute predicted outputs
  const predictedOutputs = inputs.map((inputRow) => {
    let yHat = beta[0];
    for (let i = 0; i < inputRow.length; i++) {
      yHat += beta[i + 1] * inputRow[i];
    }
    return yHat;
  });

  // Compute residual sum of squares (SSR)
  const SSR = outputs.reduce((sum, y_i, idx) => {
    const yHat_i = predictedOutputs[idx];
    return sum + Math.pow(y_i - yHat_i, 2);
  }, 0);

  // Compute total sum of squares (SST)
  const meanY = outputs.reduce((sum, y_i) => sum + y_i, 0) / outputs.length;
  const SST = outputs.reduce((sum, y_i) => {
    return sum + Math.pow(y_i - meanY, 2);
  }, 0);

  // Compute R-squared
  const rSquared = 1 - SSR / SST;

  return { beta, predictedOutputs, rSquared };
}

// Helper function to transpose a matrix
function transpose(matrix) {
  return matrix[0].map((_, colIndex) => matrix.map(row => row[colIndex]));
}

// Helper function to multiply two matrices
function multiplyMatrices(a, b) {
  let aNumRows = a.length,
    aNumCols = a[0].length,
    bNumCols = b[0].length,
    result = new Array(aNumRows);

  for (let r = 0; r < aNumRows; ++r) {
    result[r] = new Array(bNumCols);
    for (let c = 0; c < bNumCols; ++c) {
      result[r][c] = 0;
      for (let i = 0; i < aNumCols; ++i) {
        result[r][c] += a[r][i] * b[i][c];
      }
    }
  }
  return result;
}

// Helper function to compute the inverse of a matrix using Gauss-Jordan elimination
function inverseMatrix(matrix) {
  let n = matrix.length;
  // Create a deep copy of the matrix to avoid modifying the original
  let M = matrix.map(row => row.slice());

  // Initialize the identity matrix
  let identity = [];
  for (let i = 0; i < n; i++) {
    identity[i] = [];
    for (let j = 0; j < n; j++) {
      identity[i][j] = i === j ? 1 : 0;
    }
  }

  // Augment the matrix with the identity matrix
  for (let i = 0; i < n; i++) {
    M[i] = M[i].concat(identity[i]);
  }

  // Perform Gauss-Jordan elimination
  for (let i = 0; i < n; i++) {
    // Make the diagonal contain all ones
    let factor = M[i][i];
    if (factor === 0) {
      // Find a row to swap
      for (let k = i + 1; k < n; k++) {
        if (M[k][i] !== 0) {
          [M[i], M[k]] = [M[k], M[i]];
          factor = M[i][i];
          break;
        }
      }
      if (factor === 0) {
        throw new Error('Matrix is singular and cannot be inverted.');
      }
    }
    for (let j = 0; j < 2 * n; j++) {
      M[i][j] /= factor;
    }

    // Make all other elements in the current column zero
    for (let k = 0; k < n; k++) {
      if (k !== i) {
        factor = M[k][i];
        for (let j = 0; j < 2 * n; j++) {
          M[k][j] -= factor * M[i][j];
        }
      }
    }
  }

  // Extract the inverse matrix from the augmented matrix
  let inverse = [];
  for (let i = 0; i < n; i++) {
    inverse[i] = M[i].slice(n, 2 * n);
  }
  return inverse;
}

export {
  andersonDarlingTest,
  calculateCEPGaussian,
  calculateCEPRayleigh,
  calculateMRPPpValue,
  chiPDF,
  weibullPDF,
  chiRandom,
  createBins,
  dAgostinoPearsonTest,
  distance,
  fTest,
  gamma,
  gaussianRandom,
  getFurthestDistance,
  groupCenter,
  kolmogorovSmirnov,
  linearRegression,
  quadraticRegression,
  lngamma,
  mannWhitneyTest,
  multipleLinearRegression,
  rayleighProbabiltyDensity,
  standardDeviation,
  average,
  tTest,
}


